import { CreditCard } from "lucide-react";
import { PAY_LATER_URL } from "@/data/site";

export const PayLaterBanner = () => (
  <div data-testid="pay-later-banner" className="bg-brand-dark text-white p-6 sm:p-8 rounded-sm border-l-4 border-brand-ice">
    <div className="flex items-start gap-4">
      <CreditCard className="w-8 h-8 text-brand-ice shrink-0" />
      <div>
        <h3 className="font-heading font-bold text-xl">Pay over time with PayPal Pay Later</h3>
        <p className="text-blue-100 text-sm mt-2 leading-relaxed">
          A new AC system doesn't have to hit your budget all at once. Financing is available with approved credit — split your replacement into easy monthly payments through PayPal Pay Later.
        </p>
        <a href={PAY_LATER_URL} target="_blank" rel="noopener noreferrer" data-testid="pay-later-apply-link"
          className="inline-block mt-4 bg-brand-ice text-brand-ink font-bold px-6 py-3 rounded-sm hover:bg-white transition-colors duration-200 text-sm">
          Apply for Financing
        </a>
        <p className="text-xs text-blue-200 mt-3">Subject to credit approval. Pay Later options also appear automatically at PayPal checkout.</p>
      </div>
    </div>
  </div>
);
